import { PlanType } from "@brookbush/database";
import type { PlanConfig } from "@brookbush/types";

import type Stripe from "stripe";
import useSWR from "swr";

import fetcher from "~/utils/fetcher.client";

const useStripeProration = (planConfig?: PlanConfig) => {
	const {
		data: proration,
		isLoading,
		error,
	} = useSWR<Stripe.Invoice>(
		planConfig && [`/stripe/subscriptions/prorations`, planConfig],
		() =>
			fetcher(`/stripe/subscriptions/prorations`, {
				method: "POST",
				data: {
					planType: planConfig!.planType,
					priceId: planConfig!.priceId,

					promoCodeId: planConfig!.promoCodeId,
					trialLength: planConfig!.trialLength,

					quantity:
						planConfig!.planType === PlanType.TEAM
							? planConfig!.quantity
							: undefined,
				} as PlanConfig,
			}),
	);

	return { proration, isLoadingProration: isLoading, error };
};

export default useStripeProration;
